//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'saveFileResult_Id';

export default function ArchivosBodega_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: 'mensaje',
            //field: 'error',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();

    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'archivo',
            headerName: intl.formatMessage({ id: 'Archivo' }),
            editable: false,
            width: 200,
        },
        {
            field: 'paletas',
            headerName: intl.formatMessage({ id: 'Paletas' }),
            editable: false,
            width: 120,
        },
        {
            field: 'estado',
            headerName: intl.formatMessage({ id: 'Estado' }),
            editable: false,
            width: 120,
        },
        {
            field: 'mensaje',
            headerName: intl.formatMessage({ id: 'Mensaje' }),
            editable: false,
            flex: 1,
            cellClassName: (params) => {
                console.log("params", params)
                return params.row.estado == 'Error' ? 'errorColumn':''
            }
        },
    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        saveFileResult_Id: false,
    });
    return (
        <div>
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 25, 50]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: false },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }

                    getRowHeight={() => 'auto'}
                />
            </Box>
        </div>
    );
}
